import pages, { pagesConfig } from '../../config/pages';

const internalUserMenuItems = [
  // CRX menu items
  {
    pageId: pages.CRX_COACH_ONBOARDING,
    title: pagesConfig[pages.CRX_COACH_ONBOARDING].title,
  },
  {
    pageId: pages.ANALYTICS,
    title: pagesConfig[pages.ANALYTICS].title,
  },
  {
    pageId: pages.FORMS,
    title: pagesConfig[pages.FORMS].title,
  },
  {
    pageId: pages.CRX_COACH_CONFIGS,
    title: pagesConfig[pages.CRX_COACH_CONFIGS].title,
  },
  // AC menu items
  {
    pageId: pages.AC_DASHBOARD,
    title: pagesConfig[pages.AC_DASHBOARD].title,
  },
  {
    pageId: pages.DATA_MIGRATION,
    title: pagesConfig[pages.DATA_MIGRATION].title,
  },
  {
    pageId: pages.AC_LEAD_DASHBOARD,
    title: pagesConfig[pages.AC_LEAD_DASHBOARD].title,
  },
  {
    pageId: pages.COACH_TASK_ADMIN,
    title: pagesConfig[pages.COACH_TASK_ADMIN].title,
  },
  // IS menu items
  {
    pageId: pages.INSIDE_SALES_DASHBOARD,
    title: pagesConfig[pages.INSIDE_SALES_DASHBOARD].title,
  },
  {
    pageId: pages.INSIDE_SALES_LEADS,
    title: pagesConfig[pages.INSIDE_SALES_LEADS].title,
  },
  {
    pageId: pages.INSIDE_SALES,
    title: pagesConfig[pages.INSIDE_SALES].title,
  },
  {
    pageId: pages.INSIDE_SALES_COMMISSIONS,
    title: pagesConfig[pages.INSIDE_SALES_COMMISSIONS].title,
  },
  {
    pageId: pages.INSIDE_SALES_CONTRACTS_MANAGER,
    title: pagesConfig[pages.INSIDE_SALES_CONTRACTS_MANAGER].title,
  },
  {
    pageId: pages.COMMISSIONS,
    title: pagesConfig[pages.COMMISSIONS].title,
  },
  {
    pageId: pages.INTERNAL_USERS,
    title: pagesConfig[pages.INTERNAL_USERS].title,
  },
  {
    pageId: pages.IS_COACH_CONFIGS,
    title: pagesConfig[pages.IS_COACH_CONFIGS].title,
  },
  {
    pageId: pages.IS_AVAILABILITY,
    title: pagesConfig[pages.IS_AVAILABILITY].title,
  },
  // Support menu items
  {
    pageId: pages.RECIPES,
    title: pagesConfig[pages.RECIPES].title,
  },
  {
    pageId: pages.RECIPE_EDITOR,
    title: pagesConfig[pages.RECIPE_EDITOR].title,
  },
  {
    pageId: pages.REUSABLE_CONTRACTS,
    title: pagesConfig[pages.REUSABLE_CONTRACTS].title,
  },
  {
    pageId: pages.USER_MANAGEMENT,
    title: pagesConfig[pages.USER_MANAGEMENT].title,
  },
  {
    pageId: pages.AI_COACH_PROFILE,
    title: pagesConfig[pages.AI_COACH_PROFILE].title,
  },
  {
    pageId: pages.AI_COACH_INSTAGRAM_IDENTITY,
    title: pagesConfig[pages.AI_COACH_INSTAGRAM_IDENTITY].title,
  },
  {
    pageId: pages.MY_COMMISSIONS,
    title: pagesConfig[pages.MY_COMMISSIONS].title,
  },
  {
    pageId: pages.INTERNAL_ASSIGNMENTS,
    title: pagesConfig[pages.INTERNAL_ASSIGNMENTS].title,
  },
  {
    pageId: pages.COACH_VOICE,
    title: pagesConfig[pages.COACH_VOICE].title,
  },
  {
    pageId: pages.POD_SETTINGS,
    title: pagesConfig[pages.POD_SETTINGS].title,
  },
  {
    pageId: pages.CHECK_IN_THEMES,
    title: pagesConfig[pages.CHECK_IN_THEMES].title,
  },
  {
    pageId: pages.SMART_CONTEXT_ANALYTICS,
    title: pagesConfig[pages.SMART_CONTEXT_ANALYTICS].title,
  },
  // Disputes
  {
    pageId: pages.DISPUTES,
    title: pagesConfig[pages.DISPUTES].title,
  },
  // SDR menu items
  {
    pageId: pages.SDR_LEAD_INBOX,
    title: pagesConfig[pages.SDR_LEAD_INBOX].title,
  },
  {
    pageId: pages.MASS_TEXT_OUTREACH,
    title: pagesConfig[pages.MASS_TEXT_OUTREACH].title,
  },
  {
    pageId: pages.RELEASE_NOTES,
    title: pagesConfig[pages.RELEASE_NOTES].title,
  },
  {
    pageId: pages.WEBFLOW_DEPLOYER,
    title: pagesConfig[pages.WEBFLOW_DEPLOYER].title,
  },
];

export {
  internalUserMenuItems,
};
